export const chartDays = [
    {
        lable : "24 Hours",
        value : 1,
    },
    {
        lable : "30 Days",
        value : 30,
    },
    {
        lable : "1 Month",
        value : 90,
    },
    {
        lable : "1 Year",
        value : 365,
    },
]